<template>
	<div>
		<h3 style="color: #5c5d5d;">{{titulo}}</h3>
		<br />
		<table ref="tabla" class="ui table celled" style="max-height:600px;margin: 0 0;">
			<thead>
				<tr>
					<template v-for="(campo, key) in campos">
						<slot :name="`HEAD_${key}`" :campo="campo">
							<th
								:key="key"
								class="boldFont greyColor"
								:class="{ [campo.class]: true, [$style.headCheck]: key === 'check' }"
							>
								<sui-checkbox v-if="key === 'check'" v-model="checked" @change="onChangeAll"></sui-checkbox>
								<b v-else class="boldFont greyColor">
									{{
									campo.nombre
									}}
								</b>
							</th>
						</slot>
					</template>
				</tr>
			</thead>
			<tbody>
				<template v-if="!loading">
					<tr v-for="(dato, key) in value" :key="key">
						<td style="text-align: center; ">
							<sui-checkbox v-model="dato.checked" @change="onSelectItem(key,dato)"></sui-checkbox>
						</td>
						<td>{{key.toUpperCase()}}</td>
						<td>
							<BaseSelectAulas :selected="dato.claveAula" sin-titulo @input="changeAula($event,key)"></BaseSelectAulas>
						</td>
						<td>
							<BaseInputMasked
								v-model="dato.horaInicio"
								:mask="'##:##'"
								placeholder="Hora inicial"
								sin-titulo
							></BaseInputMasked>
						</td>
						<td>
							<BaseInputMasked v-model="dato.horaFin" :mask="'##:##'" placeholder="Hora final" sin-titulo></BaseInputMasked>
						</td>
					</tr>
				</template>
				<tr v-if="loading">
					<td :colspan="Object.keys(campos).length + 1">
						<div class="ui" style="position:relative;height: 600px;">
							<div style="z-index: 0;" class="ui inverted active dimmer">
								<div class="ui centered inline loader text">Cargando</div>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
export default {
	name: 'BaseTablaHorarioGrupo',
	props: {
		// elementos: {
		// 	type: Array,
		// 	default: () => []
		// },
		loading: {
			type: Boolean,
			default: false
		},
		value: {
			type: Object,
			default: function() {
				return this.valueDefault;
			}
		},
		titulo: {
			type: String,
			default: 'Horario:'
		}
	},
	data() {
		return {
			campos: {
				check: { nombre: '', class: 'one wide' },
				dia: { nombre: 'Día', class: 'three wide' },
				aula: { nombre: 'Aula', class: 'five wide' },
				horaInicial: { nombre: 'Hora inicial', class: 'three wide' },
				horaFinal: { nombre: 'Hora final', class: 'three wide' }
			},
			checked: false,
			valueDefault: {
				Lunes: { claveAula: '', horaInicio: '', horaFin: '', checked: false },
				Martes: { claveAula: '', horaInicio: '', horaFin: '', checked: false },
				Miercoles: { claveAula: '', horaInicio: '', horaFin: '', checked: false },
				Jueves: { claveAula: '', horaInicio: '', horaFin: '', checked: false },
				Viernes: { claveAula: '', horaInicio: '', horaFin: '', checked: false },
				Sabado: { claveAula: '', horaInicio: '', horaFin: '', checked: false },
				Domingo: { claveAula: '', horaInicio: '', horaFin: '', checked: false }
			}
		};
	},
	methods: {
		onSelectItem(key, item) {
			this.value[key].checked = item.checked;
			this.changeSelectAll();
		},
		changeSelectAll() {
			let i = Object.keys(this.value).length;
			for (var key in this.value) if (this.value[key].checked) i--;
			this.checked = i === 0;
		},
		onChangeAll(val) {
			this.checked = val;
			for (var key in this.value) {
				this.value[key].checked = val;
			}
		},
		changeAula(val, key) {
			this.value[key].aula = val.claveAula;
		}
	}
};
</script>
<style lang="scss" module>
@import '@design';
.headCheck {
	text-align: center !important;
	padding: 0 !important;
}
</style>